import { LocationStrategy } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { EditorService } from 'src/app/shared/services/editor.service';
import { ThemingService } from 'src/app/shared/services/theming.service';

@Component({
  selector: 'app-welcome-page',
  templateUrl: './welcome-page.component.html',
  styleUrls: ['./welcome-page.component.scss']
})
export class WelcomePageComponent implements OnInit {


  uid: any = '';
  userData: any = {}
  embedCode: string = 'lckr';
  isLckr: boolean = true;
  isCe: boolean = false;
  pay_id: any;
  is_failure: any;
  sub:any;
  theme: boolean = true;
  constructor(private editorService: EditorService,private themingService: ThemingService, private location: LocationStrategy, private route: ActivatedRoute, private toastr: ToastrService, private cookieServ: CookieService, private router: Router) {
    this.uid = this.cookieServ.get("uid");
    this.route.queryParams.subscribe(params => {
      this.pay_id = params['payment_id'];
    })
    if (!this.uid || !localStorage.getItem('auth_token')) {
      this.router.navigate([`login`])
    }
    this.themingService.getThemeName().subscribe((res: any) => {
      this.theme = res;
    })

  }

  ngOnInit(): void {
    this.themingService.pingThemeName();
    if (!!this.uid && !!localStorage.getItem('auth_token')) {
      this.autoUpdateCredit()
      this.getUserProfile();

      if (this.pay_id) {
        this.removeQueryParams();
      }   
    // this.getEmbedCodeLckr('lckr')
    
  }
}
removeQueryParams() {
  this.router.navigate(
    [],
    {
      queryParams: {
        payment_id: null,   // Remove category query param
      },
      queryParamsHandling: 'merge',
    }
  )
  if (this.pay_id==1) {
    this.toastr.success("Payment Successfull");
  }
  if (this.pay_id==2) {
    this.toastr.error("Payment failed");
  }
}

autoUpdateCredit() {
  this.editorService.updateCredit({ uid: this.uid }).subscribe((res: any) => {
    try {
      if (res) {

      }
    } catch (error) {

    }
  })
}
getUserProfile() {
  this.editorService.getUserprofile({ uid: this.uid }).subscribe(res => {
    this.userData = res.userDetails[0];
  })
}
navigateToaudit() {
  this.router.navigate(['dashboard/audit-report/audits']);
}
navigateTolckr() {
  this.router.navigate(['dashboard/lckr/keyword_finder2']);
}
navigateToContentEditor() {
  this.router.navigate(['dashboard/content-editor/editors']);
}
getEmbedCodeLckr(arg: string) {
  this.isCe = false;
  this.embedCode = arg;
  this.isLckr = !this.isLckr
}
getEmbedCodeContentEditor(arg: string) {
  this.isLckr = false;
  this.embedCode = arg;
  this.isCe = !this.isCe
}
}
